import Model, { attr, belongsTo, type AsyncBelongsTo } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type ObservationModel from './observation';
import type ScanModel from './scan';
import type SectionModel from './section';

export const RecommendationPriorityLevels = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
};

export default class RecommendationModel extends Model {
  declare [Type]: 'recommendation';
  @attr('string') declare title: string;
  @attr declare description: string;
  @attr('string') declare generation_method: string;
  @attr('string') declare priority: string;
  @belongsTo('scan', {
    async: true,
    inverse: 'recommendations',
  })
  declare scan: AsyncBelongsTo<ScanModel>;

  @belongsTo('observation', {
    async: true,
    inverse: 'recommendations',
  })
  declare observation: AsyncBelongsTo<ObservationModel>;

  @belongsTo('section', {
    async: true,
    inverse: 'recommendations',
  })
  declare section: AsyncBelongsTo<SectionModel>;
}
